import { render, staticRenderFns } from "./Multitagger.vue?vue&type=template&id=ef29155a&"
import script from "./Multitagger.vue?vue&type=script&lang=js&"
export * from "./Multitagger.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Multitagger.vue?vue&type=style&index=1&id=ef29155a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports